import { render } from "./ProductReviewText.vue?vue&type=template&id=2e740538&scoped=true"
import script from "./ProductReviewText.vue?vue&type=script&lang=js"
export * from "./ProductReviewText.vue?vue&type=script&lang=js"

import "./ProductReviewText.vue?vue&type=style&index=0&id=2e740538&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e740538"]])

export default __exports__